import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { CREATE_STORE } from "../apollo/mutations";
import closeModal from "../common/closeModal";
import { SESSION_STORAGE } from "../common/masterEnums";
import { decryptData } from "../utils/encryptData";
import { ROLES } from "../utils/encryptedConstants.";

const defaultValues = {
  name: "",
  is_active: true,
  image: "",
  owner_id: null
};

const useCreateStore = () => {

  const roles = decryptData(ROLES, SESSION_STORAGE)

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });

  const [submit] = useMutation(CREATE_STORE);

  const onAddStore = async (data) => {
    try {

      let payload = {
        variables: {
          input: {
            name: data.name,
            is_active: data.is_active,
            owner_id: data?.owner_id,
          },
          image: data.image,
        },
      };

      await submit(payload);
      reset(defaultValues);

      closeModal("add-units");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = "";
      }

    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }
  };

  return {
    values: {
      control,
      errors,
      image: watch("image"),
      roles: roles?.map(item => item?.name)
    },
    functions: {
      onSubmit: handleSubmit(onAddStore),
      onCancel,
    },
  };
};

export default useCreateStore;
